/**
 * title Table of Content
 * description Set active items on table of content on scroll
 */
function contentTable() {
    const table = document.getElementById('table-content');

    if (document.body.contains(table)) {
        const scrollLocation = window.pageYOffset;
        const contentBlocks = document.querySelectorAll('.content-block');

        for (let i = 0; i < contentBlocks.length; i++) {
            const link = document.querySelector('a[href="#'+ contentBlocks[i].id +'"]');
            if (link) {
                const siblings = getSiblings(link.parentNode);
                let sectionOffset = contentBlocks[i].offsetTop - 160;
                if (sectionOffset <= scrollLocation) {
                    link.parentNode.classList.add('font-bold');
                    for (let i = 0; i < siblings.length; i++) {
                        siblings[i].classList.remove('font-bold');
                    }
                }
            }
        }
    }
};

/**
 * title Smooth scrolling
 * description Smooth scroll for table content
 */
function tableScroll() {
    const table = document.getElementById('table-content');
    if (document.body.contains(table)) {
        const links = document.querySelectorAll("#table-content ul a");

        for (const link of links) {
          link.addEventListener("click", clickHandler);
        }

        function clickHandler(e) {
            e.preventDefault();
            const href = this.getAttribute("href");
            const offsetTop = document.getElementById(href.replace('#', '')).offsetTop - 40;

            scroll({
                top: offsetTop,
                behavior: "smooth"
            });
        }

    }
}

function getSiblings(elem) {
    let siblings = [];
    let sibling = elem.parentNode.firstChild;

    while (sibling) {
        if (sibling.nodeType === 1 && sibling !== elem) {
            siblings.push(sibling);
        }
        sibling = sibling.nextSibling
    }
    return siblings;
};

export { contentTable, tableScroll };

export default contentTable;
